/**
 * Created by wjohnald on 9/29/16.
 */

var $                 = require('js/sw-jquery/sw-jquery');
var pollingStatusLoop = require('js/lib/polling-status-loop');


/**
 *
 * View builder to views for all Polling Instances on the page.
 *
 * Once these views are created, set up a polling loop to keep them
 * up to date.
 *
 * @param $fragment
 */
module.exports = function($fragment) {

  var viewPromises = [];

  $fragment.swFindWithSelf('[data-sw-polling-instance-view]').each(function() {

    var $el = $(this);
    var id = $el.data('swPollingInstanceView');
    var deferred = $.Deferred();

    viewPromises.push(deferred);

    require(['js/lib/models/ModelManager', 'js/lib/views/PollingInstanceView'], function(ModelManager, PollingInstanceView) {

      ModelManager.amdPollingInstanceById(id, function(pollingInstance) {

        if (pollingInstance) {

          new PollingInstanceView({
            el: $el,
            model: pollingInstance
          });

          deferred.resolve();
          
        }

      });

    });

  });

  // Invoke the polling status loop if we have built any views. This pattern
  // ensures that all the models that need to be loaded have been loaded
  if (viewPromises.length) {
    $.when.apply($, viewPromises).then(function() {
      pollingStatusLoop();
    });
  }



};
